'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPortalReporter = exports.makePortalReporter = exports.ClickableContextProvider = exports.ClickableContextConsumer = exports.defaultClickableContext = undefined;

var _react = require('react');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultClickableContext = exports.defaultClickableContext = function defaultClickableContext() {};

var _createContext = (0, _react.createContext)(defaultClickableContext),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.ClickableContextConsumer = Consumer;
exports.ClickableContextProvider = Provider;


var hasReportedPortal = false;
var makePortalReporter = exports.makePortalReporter = function makePortalReporter(getPortalReporterDetails) {
  return function (layerFor) {
    if (hasReportedPortal) return;

    var _getPortalReporterDet = getPortalReporterDetails(),
        componentName = _getPortalReporterDet.componentName,
        labelText = _getPortalReporterDet.labelText;

    var message = 'A portal component (`' + layerFor + '`) was rendered in a `' + componentName + '`';
    message += labelText ? ' labeled "' + labelText + '".' : '.';

    _devLogger2.default.warn({
      message: message,
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6275',
      key: 'portal-in-' + componentName
    });
  };
};

// For testing only
var resetPortalReporter = exports.resetPortalReporter = function resetPortalReporter() {
  hasReportedPortal = false;
};